
import React from "react";
import { ResourceCardActions } from "./ResourceCardActions";
import { Card, CardContent, CardFooter, CardHeader } from "@/components/ui/card";
import { ShareResourceDialog } from "./ShareResourceDialog";

interface AdminResourceCardProps {
  resource: any;
  id?: string;
  topic?: string;
  company?: string;
  status?: string;
  previewImageUrl?: string;
  createdAt?: string;
}

export function AdminResourceCard({ 
  resource, 
  id,
  topic,
  company,
  status,
  previewImageUrl,
  createdAt 
}: AdminResourceCardProps) {
  // If we're getting individual props, construct a resource object
  const resourceData = resource || {
    id: id,
    topic: topic,
    company: company,
    status: status,
    preview_image_url: previewImageUrl,
    created_at: createdAt
  };

  return (
    <Card className="overflow-hidden flex flex-col h-full transition-all hover:shadow-md">
      <CardHeader className="p-0">
        <div 
          className="aspect-video bg-cover bg-center w-full" 
          style={{ 
            backgroundImage: `url(${resourceData.preview_image_url || '/placeholder.svg'})`,
            backgroundColor: resourceData.primary_color || '#9b87f5'
          }}
        />
      </CardHeader>
      <CardContent className="p-4 flex-grow">
        <h3 className="font-bold text-lg mb-1 line-clamp-2">{resourceData.topic}</h3>
        <p className="text-sm text-muted-foreground">{resourceData.company}</p>
      </CardContent>
      <CardFooter className="p-4 pt-0 flex flex-col gap-2">
        <div className="flex flex-col gap-2 w-full">
          <ResourceCardActions 
            resourceId={resourceData.id} 
            isResourceCompleted={false}
            isTrainee={false}
            topic={resourceData.topic}
            company={resourceData.company}
            previewImageUrl={resourceData.preview_image_url}
          />
          
          <ShareResourceDialog 
            resourceId={resourceData.id}
            topic={resourceData.topic}
            company={resourceData.company}
            previewImageUrl={resourceData.preview_image_url}
          />
        </div>
      </CardFooter>
    </Card>
  );
}
